import CodeBlock from "@tiptap/extension-code-block";
import { Document } from "@tiptap/extension-document";
import HorizontalRule from "@tiptap/extension-horizontal-rule";
import Link from "@tiptap/extension-link";
import Strike from "@tiptap/extension-strike";
import { Editor, useEditor as useTiptapEditor } from "@tiptap/react";
import RTEOrderedList from "@tiptap/extension-ordered-list";
import Underline from "@tiptap/extension-underline";
import { IGeniusNode } from "@/types/models/GenerationGenius.interface";

import ContentDrawerGroup from "@/view/TiptapArticleBody/extensions/ContentDrawerGroup";

import { Core } from "@/view/TiptapArticleBody/extensions/core";
import { HardBreakBlock } from "@/view/TiptapArticleBody/extensions/HardBreakBlock";
import HeadingBlock from "@/view/TiptapArticleBody/extensions/HeadingBlock";
import IgnoreBlock from "@/view/TiptapArticleBody/extensions/IgnoreBlock";
import { Image } from "@/view/TiptapArticleBody/extensions/Image";
import { Language } from "@/view/TiptapArticleBody/extensions/Language";
import {
  OrderedList,
  OrderedListItem,
  UnorderedList,
  UnorderedListItem,
} from "@/view/TiptapArticleBody/extensions/List";
import ParagraphBlock from "@/view/TiptapArticleBody/extensions/ParagraphBlock";
import PreformattedBlock from "@/view/TiptapArticleBody/extensions/PreformattedBlock";
import QuoteBlock from "@/view/TiptapArticleBody/extensions/QuoteBlock";

export interface IUseEditorProps {
  content: IGeniusNode | null;
}

const useGeniusEditor = ({ content }: IUseEditorProps): Editor | null => {
  const config = {
    editorProps: {
      attributes: {
        class: "generation-genius-content",
        "data-testid": "generation-genius-editor",
      },
    },
    extensions: [
      Core,
      ContentDrawerGroup,
      Document,
      HeadingBlock,
      Link,
      Image,
      Language,
      ParagraphBlock,
      HardBreakBlock,
      PreformattedBlock,
      QuoteBlock,
      IgnoreBlock,
      OrderedList,
      /* RTEOrderedList extensions allows Ordered Lists from the Rich Text Editor to be displayed properly */
      RTEOrderedList,
      OrderedListItem,
      UnorderedList,
      UnorderedListItem,
      HorizontalRule,
      Strike,
      CodeBlock,
      Underline,
    ],
    content,
    editable: false,
  };

  return useTiptapEditor(config, [content]);
};

export default useGeniusEditor;
